<template>
  <div class="table-inside" v-loading="loading" element-loading-text="正在加载轮播图...">
    <!-- 顶部banner轮播 -->
    <div class="carousel_wrap">
      <el-carousel
          loop
          arrow="never"
          indicator-position="bottom"
          class="full-show-carousel top-carousel"
      >
        <el-carousel-item v-for="(item, index) in topImgList" :key="index">
          <img :src="item.src" alt="顶部轮播图" class="img_item" />
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- 系列展示区域：logo行 + 详情大图行 -->
    <div class="series-show-wrap">
      <!-- 第一行：4个logo横向排列（不动） -->
      <div class="logo-row">
        <ul class="logo-list">
          <li
              v-for="(series, idx) in logoList"
              :key="idx"
              class="logo-item"
          >
            <img :src="series.src" class="logo-img" :alt="series.title" />
            <div class="logo-text">
              <p class="logo-title">{{ series.title }}</p>
              <p class="logo-en">{{ series.en }}</p>
            </div>
          </li>
        </ul>
      </div>

      <!-- 第二行：logoList循环展示 -->
      <div class="series-big-banner"
           v-for="(item,ins) in tableProductList"
           :key="item.id">
        <!-- 系列标题：独立在图片上方 -->
        <div class="banner-title">
          <h3>{{ item.name }}</h3>
          <p>{{ item.alias }}</p>
        </div>
        <!-- 系列大图 -->
        <img
            :src="item.url+item.thumbnailSrc"
            :alt="item.name"
            class="banner-img"
            v-if="ins === 0"
            style="cursor: pointer"
            @click="handTableDetail(item.children[0].id)"
        />
        <img
            :src="item.url+item.thumbnailSrc"
            :alt="item.name"
            class="banner-img"
            v-if="ins !== 0"
        />

        <!-- 核心：id=233时显示箭头+点击事件 -->
<!--        <div class="arrow-wrap" v-if="ins === 0" @click="handTableDetail(item.children[0].id)">-->
<!--          <img src="@/assets/img/table/arrow.png" alt="系列箭头" class="arrow-img" />-->
<!--        </div>-->

        <!-- 非233id显示产品列表 -->
        <div class="qz-content" v-if="ins !== 0">
          <div class="qz-product">
            <div class="qz-container">
              <div class="table-product-list">
                <ul>
                  <li v-for="child in item.children" :key="child.id">
                    <a @click="handTableDetail(child.id)" class="product-card">
                      <div class="product-img">
                        <img :src="child.url + child.thumbnailSrc" :alt="child.name" />
                      </div>
                      <div class="product-info">
                        <h3 class="product-name">{{ child.name }}</h3>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第三部分 台球配件系列 -->
      <div class="series-big-banner"
           v-for="(item, idx) in assyList"
           :key="idx">
        <!-- 系列标题：独立在图片上方 -->
        <div class="banner-title">
          <h3>{{ item.title }}</h3>
          <p>{{ item.en }}</p>
        </div>
        <!-- 系列大图 -->
        <img
            :src="item.bigImg"
            :alt="item.title + '系列大图'"
            class="banner-img"
            style="cursor: pointer"
            @click="handTableDetail(item.id)"
        />

        <div class="qz-content">
          <div class="qz-product">
            <div class="qz-container">
              <div class="table-product-list">
                <ul>
                  <li v-for="(item, index) in V800List" :key="index">
                    <a :href="item.url" target="" class="product-card">
                      <div class="product-img">
                        <img :src="item.bigImg" />
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {getImgList, getProductClassifyById} from "@/api/home";
import { ImageTypeEnum } from "@/enums/imageTypeEnum";

export default {
  data() {
    return {
      loading: false,
      topImgList: [],
      tableProductList: [],
      // 系列数据
      logoList: [
        {
          src: require("@/assets/img/table/pinpai_01.png"),
          title: "美洲豹系列",
          en: "PREDATOR SERIES",
          bigImg: require("@/assets/img/table/xl-big/pre.png")
        },
        {
          src: require("@/assets/img/table/S.png"),
          title: "璟点S系列",
          en: "S SERIES",
          bigImg: require("@/assets/img/table/xl-big/S.png")
        },
        {
          src: require("@/assets/img/table/X.png"),
          title: "璟点X系列",
          en: "X SERIES",
          bigImg: require("@/assets/img/table/xl-big/X.png")
        },
        {
          src: require("@/assets/img/table/akz.png"),
          title: "阿卡兹系列",
          en: "AKZ SERIES",
          bigImg: require("@/assets/img/table/xl-big/akz.png")
        }
      ],
      assyList: [
        {
          title: "台球配件系列",
          en: "TAIQIUPEIJIAN SERIES",
          bigImg: require("@/assets/img/table/xl-big/assy.png"),
          id:'505'
        },
      ],
      V800List: [
          //V800
        {
          bigImg: require("@/assets/img/table/V800.png"),
          url: '',
        },
        //易胜
        {
          bigImg: require("@/assets/img/table/ys.png"),
          url: '/website?type=ys',
        },
      ]
    };
  },
  created() {
    this.getBannerList();
    this.parseChildProducts();
  },
  methods: {
    //获取轮播图
    async getBannerList() {
      try {
        this.loading = true;
        const typeStr = `${ImageTypeEnum.TABLE_HOME_LIST.value}`;
        const res = await getImgList(typeStr);
        const dataList = res.data || [];
        this.topImgList = dataList.filter(item => item.classify === ImageTypeEnum.TABLE_HOME_LIST.value && item.src);
      } catch (error) {
        console.error("获取轮播图失败：", error);
        this.$message?.error("轮播图加载失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    //获取台球桌列表信息
    async parseChildProducts() {
      try {
        this.loading = true;
        const parentId = ImageTypeEnum.TABLE_PRODUCT_DETAIL_LIST.value;
        const res = await getProductClassifyById(parentId);
        if (res.code === 200) {
          this.tableProductList = res.data[0].children;
          console.log(203,this.tableProductList)
        } else {
          this.$message.error(res.msg || "获取产品详情失败");
        }
      } catch (error) {
        console.error("产品详情请求失败：", error);
        this.$message.error("网络异常，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    //台球列表点击事件
    handTableDetail(productId){
      this.$router.push({
        path: '/table_sc',
        query: {
          productId: productId,
          type: 'table'
        }
      });
    },
  }
};
</script>

<style scoped lang="scss">
/* 基础样式：移动端去掉max-width限制 */
.table-inside {
  margin-top: 100px;
  width: 100%;
  overflow: hidden;
  @media (max-width: 768px) {
    margin-top: 60px;
    max-width: none !important;
    width: 100vw !important;
  }
}

.carousel_wrap {
  position: relative;
  width: 100%;
  @media (max-width: 768px) {
    padding-bottom: 20px;
    max-width: none !important;
    width: 100vw !important;
  }
}

.full-show-carousel {
  width: 100%;
  height: auto !important;
  .el-carousel__item {
    width: 100%;
    height: auto !important;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f5f5;
    .img_item {
      width: 100%;
      height: auto;
      object-fit: contain;
      display: block;
    }
  }
  .el-carousel__indicators {
    bottom: 20px;
    @media (max-width: 768px) {
      bottom: 10px;
    }
  }
}

.top-carousel {
  height: 35vw !important;
  .el-carousel__item {
    background: #fff;
  }
}

// 系列展示区域核心样式
.series-show-wrap {
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid #eee;

  // 第一行：logo行
  .logo-row {
    padding: 30px 0;
    .logo-list {
      width: 90%;
      max-width: 1600px;
      margin: 0 auto;
      padding: 0;
      list-style: none;
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-wrap: wrap;

      .logo-item {
        flex: 1;
        text-align: center;
        padding: 0 15px;
        display: flex;
        flex-direction: column;
        align-items: center;

        // 固定logo高度，保证所有logo高度一致
        .logo-img {
          width: auto;
          height: 80px;
          max-height: none;
          object-fit: contain;
          margin: 0 auto 10px;
          display: block;
          @media (max-width: 768px) {
            height: 50px;
          }
        }

        .logo-text {
          .logo-title {
            margin: 0 0 5px 0;
            font-size: 16px;
            color: #333;
            font-weight: 600;
            @media (max-width: 768px) {
              font-size: 12px;
            }
          }

          .logo-en {
            margin: 0;
            font-size: 12px;
            color: #666;
            letter-spacing: 1px;
            @media (max-width: 768px) {
              font-size: 10px;
            }
          }
        }
      }
    }
  }

  // 系列详情大图（标题独立在图片上方）
  .series-big-banner {
    width: 100%;
    overflow: hidden;

    .banner-title {
      padding: 20px 0;
      text-align: center;
      h3 {
        margin: 0 0 5px 0;
        font-size: 32px;
        font-weight: 600;
        color: #333;
      }
      p {
        margin: 0;
        font-size: 18px;
        letter-spacing: 10px;
        color: #333;
      }
      @media (max-width: 768px) {
        padding: 10px 0;
        h3 {
          font-size: 18px;
        }
        p {
          font-size: 12px;
        }
      }
    }

    .banner-img {
      width: 100%;
      height: auto;
      display: block;
    }

    // 核心：箭头容器样式（居中+间距）
    .arrow-wrap {
      padding: 30px 0; // 大图与箭头的间距
      text-align: center; // 箭头居中
      cursor: pointer; // 鼠标悬浮为手型
      .arrow-img {
        width: 80px; // 箭头大小，可根据设计图调整
        height: auto;
        transition: transform 0.2s ease; // 轻微hover效果（可选）
        &:hover {
          transform: translateX(5px); // 箭头轻微右移（可选，可删除）
        }
      }
      @media (max-width: 768px) {
        padding: 15px 0;
        .arrow-img {
          width: 30px; // 移动端箭头缩小
        }
      }
    }
  }
}

// ========== 核心修改1：背景色改为白色 ==========
.qz-content {
  background: #fff !important; // 改为白色
  padding: 0 !important;
  @media (max-width: 768px) {
    max-width: none !important;
    width: 100vw !important;
  }
}

.qz-product {
  padding: 5% 0 3% 0;
  background: #fff !important; // 移除背景图，改为白色
  min-height: auto !important; // 取消固定最小高度，自适应内容
  position: relative;
  width: 100%;
  box-sizing: border-box;
  @media (max-width: 768px) {
    padding: 8% 0 10% 0;
    max-width: none !important;
    width: 100vw !important;
  }
}

.qz-container {
  position: relative;
  max-width: 1370px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
  z-index: 1;
  @media (max-width: 768px) {
    max-width: none !important;
    width: 100vw !important;
    padding: 0 15px;
  }
}

// ========== 核心修改2：产品列表左对齐 + 白色背景 ==========
.table-product-list {
  width: 100%;
  margin-top: 40px;
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 20px; // 2个元素仅1个间隙，保持间距统一
    justify-content: flex-start; // 核心：左对齐（替代原来的center）
    overflow: hidden;
    @media (max-width: 768px) {
      gap: 15px;
      max-width: none !important;
    }
  }

  li {
    // PC端：每行2个，宽度=(总宽度 - 间隙)/2
    width: calc((100% - 20px) / 2) !important;
    flex-basis: calc((100% - 20px) / 2) !important;
    max-width: calc((100% - 20px) / 2) !important;
    flex: 0 0 auto !important;
    box-sizing: border-box !important;
    margin: 0 !important;
    // 移动端：保持每行2个，计算式=(总宽度 - 移动端间隙)/2
    @media (max-width: 768px) {
      width: calc((100% - 15px) / 2) !important;
      flex-basis: calc((100% - 15px) / 2) !important;
      max-width: calc((100% - 15px) / 2) !important;
      margin-bottom: 15px !important;
    }

    .product-card {
      display: flex;
      flex-direction: column;
      width: 100% !important;
      height: 100%;
      text-decoration: none;
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      @media (max-width: 768px) {
        border-radius: 4px;
      }
    }

    .product-img {
      width: 100% !important;
      aspect-ratio: 1 / 1;
      overflow: hidden;
      background: #fff !important; // 图片容器背景改为白色
      img {
        width: 100% !important;
        height: 100% !important;
        object-fit: contain;
        transition: none; // 去掉鼠标缩放效果
        border-radius: 10px;
      }
    }

    .product-info {
      width: 100% !important;
      padding: 15px 10px;
      flex: 1;
      box-sizing: border-box;
      @media (max-width: 768px) {
        padding: 10px 8px;
      }

      .product-name {
        margin: 0 0 8px 0;
        font-size: 20px;
        color: #333;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @media (max-width: 768px) {
          font-size: 16px;
        }
      }

      .product-desc {
        margin: 0;
        font-size: 14px;
        color: #666;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        @media (max-width: 768px) {
          font-size: 12px;
        }
      }
    }
  }
}
</style>